import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { Title as TitleBase } from 'components/misc'

export const Title = styled(TitleBase)`
  ${mq.smallOnly} {
    margin-top: 10rem;
  }
`
export const Figure = styled.figure`
  margin: 6rem 0;
  text-align: center;

  img {
    max-width: 100%;
  }

  svg {
    max-width: 76rem;
  }
`

export const Figcaption = styled.figcaption`
  margin-top: 1rem;
`
